module.exports = __webpack_public_path__ + "img/reference-hausmeister-mario.8c52ee12.webp";